var mobileHeaderBreakpoint = '(max-width: 1024px)';

// Overwrites native 'lastElementChild' prototype.
// Adds Document & DocumentFragment support for IE9 & Safari.
// Returns array instead of HTMLCollection.
;(function(constructor) {
    if (constructor &&
        constructor.prototype &&
        constructor.prototype.lastElementChild == null) {
        Object.defineProperty(constructor.prototype, 'lastElementChild', {
            get: function() {
                var node, nodes = this.childNodes, i = nodes.length - 1;
                while (node = nodes[i--]) {
                    if (node.nodeType === 1) {
                        return node;
                    }
                }
                return null;
            }
        });
    }
})(window.Node || window.Element);

(function() {
  // Header navigation
  var header = document.querySelector('.header');
  var activeDropdown = document.querySelector('.show-menu');
  var toggleItems = document.querySelectorAll('.header__link--has-children');
  var dropdownToggles = document.querySelectorAll('.header__bottom-link--has-children');
  var isMobile = window.matchMedia(mobileHeaderBreakpoint);

  for (var i = 0; i < toggleItems.length; i++) {
    var toggle = toggleItems[i];
    toggle.addEventListener('click', onToggleItemClick);
  }

  for (var i = 0; i < dropdownToggles.length; i++) {
    var toggle = dropdownToggles[i];
    var button = toggle.querySelector('button');
    toggle.addEventListener('mouseenter', onDropdownToggleItemEnter.bind(toggle));
    toggle.addEventListener('mouseleave', onDropdownToggleItemLeave.bind(toggle));
    button.addEventListener('click', onDropdownToggleItemClick.bind(button));
  }

  function onDropdownToggleItemEnter() {
    if (isMobile.matches) {
      return false;
    }

    this.classList.add('dropdown-show');
  }

  function onDropdownToggleItemLeave() {
    if (isMobile.matches) {
      return false;
    }

    this.classList.remove('dropdown-show');
  }

  function onDropdownToggleItemClick() {
    if (!isMobile.matches) {
      return false;
    }

    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', expanded ? 'false' : 'true')
    this.parentElement.classList.toggle('dropdown-show');
  }

  function onToggleItemClick(e) {
    if (!isMobile.matches) {
      return false;
    }

    e.preventDefault();

    // Clean up previously set active dropdown
    if (activeDropdown) {
      activeDropdown.classList.remove('show-menu');
      updateAriaState(activeDropdown, false);
    }

    if (activeDropdown !== e.target.parentElement) {
      activeDropdown = e.target.parentElement;
      activeDropdown.classList.add('show-menu');
      updateAriaState(activeDropdown, true);
      header.classList.add('header--subnav');
    } else {
      activeDropdown = null;
      header.classList.remove('header--subnav');
    }
  }

  function updateAriaState(dropdown, expand) {
    var expanded = expand === true ? 'true' : 'false';
    var tabindex = expand === true ? '0' : '-1';

    // Update expanded
    dropdown.querySelector('a').setAttribute('aria-expanded', expanded);

    // Update tabindex, prevent/make links keyboard focusable
    var links = dropdown.querySelectorAll('.header__bottom-link');
    for (var j = 0; j < links.length; j++) {
      links[j].setAttribute('tabindex', tabindex);
    }
  }

  // Mobile menu stuff
  var toggle = document.querySelector('.menu-toggle');
  var menu = document.querySelector('.menu');

  toggle.addEventListener('click', function() {
    menu.classList.toggle('menu--show');
  });
})();

(function() {
  // Accordion
  var accordions = document.getElementsByClassName('accordion');

  for (var i = 0; i < accordions.length; i++) {
    var accordion = accordions[i];
    var panels = accordion.getElementsByClassName('accordion__panel');

    for (var j = 0; j < panels.length; j++) {
      var panel = panels[j];
      var header = panel.querySelector('header');

      header.addEventListener('click', onAccordionHeaderClick.bind(panel));
      header.addEventListener('keydown', onAccordionHeaderClick.bind(panel));
    }
  }

  function onAccordionHeaderClick(e) {
    if (e.keyCode && e.keyCode !== 13) {
      return false;
    }

    var targetPanel = this;
    var isExpanded = targetPanel.classList.contains('accordion__panel--active');

    if (isExpanded) {
      // Reset other accordion body heights
      targetPanel.classList.remove('accordion__panel--active');
      targetPanel.querySelector('.accordion__header').setAttribute('aria-expanded', 'false');
      targetPanel.querySelector('.accordion__body').style.maxHeight = '0px';
    } else {
      // Expand in the next frame
      setTimeout(function() {
        var body = targetPanel.querySelector('.accordion__body');
        targetPanel.querySelector('.accordion__header').setAttribute('aria-expanded', 'true');
        var maxHeight = body.children[0].offsetHeight;

        targetPanel.classList.add('accordion__panel--active');
        body.style.maxHeight = maxHeight + 'px';
      }, 1);
    }
  }

})();

(function() {
  // Program detail more/less info
  var section = document.querySelector('.program-detail__more');
  var show = 'more';
  if (section) {
    var button = section.querySelector('.btn');

    button.addEventListener('click', function() {
      show = show === 'more' ? 'less' : 'more';
      expanded = show === 'more' ? 'false' : 'true';
      button.textContent = button.dataset[show];

      section.setAttribute('aria-expanded', expanded);
      section.classList.toggle('program-detail__more--show');
      button.blur();
    });
  }
})();

// Ajax articles fetching
(function() {
  var wrap = document.querySelector('.articles-grid');
  var button = document.querySelector('.btn-load-resources');
  var page = 1; // default page

  if (button) {
    button.addEventListener('click', function() {
      // Fetch the next page of resources
      page += 1;
      ajaxGetResources(page);
    });

    function ajaxGetResources(page) {
      var data = {
        action: 'get_resources',
        paged: page
      };

      jQuery.post(pinepoint_app.ajax_url, data, function(response) {
        $response = jQuery(response);
        $children = $response.children();

        if ($children.length) {
          jQuery(wrap).append($children);

          // Hide button if there are less than 6 children
          if ($children.length < 6) {
            button.remove();
          }
        } else {
          // Hide button if there are no more children
          button.remove();
        }
      });
    }
  }
})();
